"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pageable = void 0;
class Pageable {
    get hasData() {
        return this.data && this.data.length;
    }
    get first() {
        return this.hasData ? this.data[0] : null;
    }
    get nextSkip() {
        return this.options.skip + this.options.limit;
    }
    constructor(pageable = {}) {
        const options = pageable.options;
        this.options = {
            limit: options && options.limit ? options.limit : 10,
            skip: options && options.skip ? options.skip : 0,
        };
        this.data = pageable.data || [];
    }
}
exports.Pageable = Pageable;
//# sourceMappingURL=pageable.js.map